const escapedLt = `\\u${'<'.charCodeAt(0).toString(16).padStart(4, '0')}`;
const sanitizeJSON = (json) => json.replace(/</g, escapedLt);

export default (state) => {
  const { pageTitle, pageMetaData, breadcrumbsArr } = state;
  const title = `${pageTitle} | REI Classes & Events`;
  const { canonical } = pageMetaData;

  // Not set index or follow from headlamp yet, so use canonical info for now
  const restrictRobots = /events\/search/.test(canonical);

  return {
    meta: [
      {
        vmid: 'robots',
        name: 'robots',
        content: restrictRobots ? 'noindex,nofollow' : 'index,follow',
      },
    ],
    title,
    script: [
      breadcrumbsArr && {
        vmid: 'breadcrumbLdJson',
        type: 'application/ld+json',
        innerHTML: sanitizeJSON(
          JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbsArr.map((crumb, ix) => ({
              '@type': 'ListItem',
              position: ix + 1,
              item: {
                '@id': crumb.canonicalLink && `${origin}${crumb.canonicalLink}`,
                name: crumb.label,
              },
            })),
          }),
        ),
      },
    ].filter((s) => s),
    __dangerouslyDisableSanitizersByTagID: {
      breadcrumbLdJson: ['innerHTML'],
    },
  };
};
